import RouteUtils from './RouteUtils.js'
import Interface from './Interface.js'
import { User } from './authz/index.js'
import { Resource, Resources } from './rsrc/index.js'
import ResourceEnum from './ResourceEnum.js'
import ResourceEnums from './ResourceEnums.js'
import Srv from './Srv.js'
import Device from './Device.js'
import Rule from './Rule.js'
import Rules from './Rules.js'
import ApiAccessKey from './ApiAccessKey.js'
import ApiAccessKeys from './ApiAccessKeys.js'

export default function SystemApi( api, sys, isRoot = true ) {
  
  let path = null
  if ( sys ) {
    if ( typeof sys === 'string' ) {
      path = `${isRoot ? 'v1/' : ''}system/${sys}`
    } else if ( sys.id ) {
      path = `${isRoot ? 'v1/' : ''}system/${sys.id}`
    }
  }

  if ( path == null ) {
    throw new Error( 'invalid system' )
  }

  const connect = api.child( path )

  function _interface( type ) {
    return Interface( api, sys, type )
  }

  // For backwards compat
  const device = ( id ) => {
    return Device( connect, id, false )
  }

  /**
   * For history and events.list see the Device/history and Device/events/list documentation
   * the only difference is the addition of the deviceId and blueprintId root paths.
   */
  device.history = ( q, query ) => { 
    return connect.child( 'device/history' ).get( { ...query, q : JSON.stringify( q ) } ) 
  }
  device.events = () => {
    return {
      list : ( q, query ) => connect.child( 'device/events' ).get( { ...query, q : JSON.stringify( q ) } )
    }
  }

  return {
    get : connect.get,
    update : connect.patch,
    delete : connect.delete,
    srv( type ) { return new Srv( connect, type ) },
    user( id ) { return new User( connect, id ) },
    users() { 
      return RouteUtils.authzUsers( connect, 'user' )
    },
    devices( ) { return RouteUtils.collection( connect, 'device' ) },
    contacts( ) { return RouteUtils.collection( connect, 'contact', true, true ) },
    interface : _interface,
    userDevices( ) { 
      const r = RouteUtils.collection( connect, 'userDevice' ) 
      delete r.create
      return r
    },
    device,
    verify( options ) { return connect.child( 'verify' ).get( options, { useRefresh : true } ) },

    resourceEnums() { return new ResourceEnums( connect ) },
    resourceEnum( type ) { return new ResourceEnum( connect, type, true, true ) },

    resource( rsrc ) { return new Resource( connect, rsrc ) },
    resources() { return new Resources( connect ) },
    rules() { return new Rules( connect, false ) },
    rule( id ) { return new Rule( connect, id ) },

    apiAccessKeys() { return new ApiAccessKeys( connect.child( 'apiAccess' ) ) },
    apiAccessKey( id ) { return new ApiAccessKey( connect.child( 'apiAccess' ), id ) }
  }
}
